export const searchMatch = (searchValue: string, testWord: string) => {
  return testWord.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase());
};
